import PropTypes from 'prop-types'
import React from 'react'

export default function PaneWrapper({ children }) {
  return (
    <div className="app-pane highlight pane column-md">
      <div className="vertical user-layout">
        {children}
      </div>
    </div>
  )
}

PaneWrapper.propTypes = {
  children: PropTypes.node
}



// WEBPACK FOOTER //
// ./src/user/components/PaneWrapper.js